import * as React from "react";
// world_map_svg__st1
import './SvgWorldMap.scss'

const SvgLocationPoint = (props) => {

  const { className, x, y, r, id } = props

  const disabledClass = props.disabled === true ? `disabled` : ``;
  const onClick = props.disabled === true ? undefined : props.onClick;

  return (
    <circle
      className={`world_map_svg__st1 ${className} ${disabledClass}`}
      id={id}
      cx={x}
      cy={y}
      r={r}
      onClick={onClick}
    />
  );
}

export default SvgLocationPoint;

